<template>
  <div v-if="$store.state.showMessage" class="overlay">
    <div class="outer" ref="outer">
      <img src="/img/pickl-logo.png" class="img-responsive" /><br />
      <div class="msg" v-html="$store.state.message"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FullscreenMessage',
  data() {
    return {
      message: ''
    }
  }
}

</script>

<style scoped>

@keyframes fade {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

.outer {
  max-width: 213px;
  width: 30%;
  padding: 2%;
  background-color: #782b54;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  animation: fade 1s ease-in;
  z-index: 1060;
  border-radius: 3%;
  box-shadow: 0px 0px 3px 3px #782b54;
}

.img {
  width: 100%;
}

.msg {
  text-align: center;
  color: white;
  font-weight: 500;
  font-size: 17px;


}

.overlay {
  background-color: transparent;
  cursor: auto;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  z-index: 1060;
}
</style>
